import { render, staticRenderFns } from "./BpCurrentLiabilitiesToNetWorthRatioDisplayer.vue?vue&type=template&id=09e7d6fc"
import script from "./BpCurrentLiabilitiesToNetWorthRatioDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpCurrentLiabilitiesToNetWorthRatioDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports